import { useTransition, UseTransitionResult } from 'react-spring';

export function useFadeTransition(active: boolean): UseTransitionResult<boolean, React.CSSProperties>[] {
  return useTransition(active, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });
}
